import { render, staticRenderFns } from "./SundryItemPriceList.vue?vue&type=template&id=369008ba&scoped=true&"
import script from "./SundryItemPriceList.vue?vue&type=script&lang=js&"
export * from "./SundryItemPriceList.vue?vue&type=script&lang=js&"
import style0 from "./SundryItemPriceList.vue?vue&type=style&index=0&id=369008ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369008ba",
  null
  
)

export default component.exports